"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorTag = void 0;
exports.ErrorTag = {
  NetworkError: 'NetworkError'
};